import {
  WSButton,
  WSElement,
  WSFlexBox,
  WSInfoBox,
  WSList,
  WSPill,
  WSText
} from "@wingspanhq/fe-component-library";
import { useState } from "react";
import type { resourceEventHistoryApiSpec } from "@wingspanhq/wingspan-api-types";
import { EventContent } from "./EventContent";
import { pluralizeEventTitle } from "./pluralizeEventTitle";
import { EventGroup } from "./types";

type Props = {
  group: EventGroup & { type: "grouped" };
  isCompact?: boolean;
  drillDownResourceType?: string;
  onDrillDown?: (resource: resourceEventHistoryApiSpec.IEventResource) => void;
};

export const EventGroupContent: React.FC<Props> = props => {
  const [isExpanded, setIsExpanded] = useState(false);

  const anchorEvent = props.group.events[0];
  const isActorDifferentFromOwner =
    anchorEvent.actorName && anchorEvent.actorName !== anchorEvent.userName;

  return (
    <WSElement>
      <WSText.ParagraphSm color="gray600">
        {pluralizeEventTitle(props.group.eventTitle, props.group.events.length)}
      </WSText.ParagraphSm>

      {isActorDifferentFromOwner && (
        <WSFlexBox mt="M" direction="column">
          <WSFlexBox alignItems="center" mb="M">
            <WSText.ParagraphSm color="gray600">Team member</WSText.ParagraphSm>
            <WSPill icon="lock" text="Private" theme="neutral" ml="M" />
          </WSFlexBox>
          <WSInfoBox>Action taken by {anchorEvent.actorName}</WSInfoBox>
        </WSFlexBox>
      )}

      {isExpanded ? (
        <>
          <WSInfoBox mt="M">
            <WSList gap="M">
              {props.group.events.map(event => (
                <WSElement key={event.resourceEventId}>
                  <EventContent
                    event={event}
                    isCompact={props.isCompact}
                    hideTeamMember
                    drillDownResourceType={props.drillDownResourceType}
                    onDrillDown={props.onDrillDown}
                  />
                </WSElement>
              ))}
            </WSList>
          </WSInfoBox>
          <WSButton.Link
            size="S"
            ml="NONE"
            pl="NONE"
            mt="S"
            onClick={() => setIsExpanded(false)}
          >
            See less
          </WSButton.Link>
        </>
      ) : (
        <WSButton.Link
          size="S"
          ml="NONE"
          pl="NONE"
          onClick={() => setIsExpanded(true)}
        >
          See more
        </WSButton.Link>
      )}
    </WSElement>
  );
};
